import './main.scss';

window.addEventListener('load', async () => {
	if ('serviceWorker' in navigator) {
		try {
			const reg = await navigator.serviceWorker.register('/sw.js')
		} catch (e) {
			console.log('Service worker register fail')
		}
	}
	
	// Change first day data
	if (document.querySelector('.day')) {
		let date      = new Date,
				today     = date.getDay(),
				days      = document.querySelectorAll('.day'),
				todayWrap = document.querySelector('.today');
		
		if (today > 0 && today < 6) {
			todayWrap.innerHTML = days[today - 1].innerHTML;
		} else {
			todayWrap.innerHTML = days[0].innerHTML;
		}
	}
})